import styled from 'styled-components'

export const ProgressCourse = styled.div`
  .progress {
    height: 25px;
  }
`